import dayjs from 'dayjs';
import React, { useState } from 'react';

import DatePicker, { IDatePickerProps } from '../DatePicker/DatePicker';

interface IDatePickerModalContent extends IDatePickerProps {
  initialFrom?: Date;
  isCalendarMinimumNightsSelectorEnabled?: boolean;
}

export const DatePickerModalContent = ({
  onChange,
  disabledDays,
  disableBefore,
  dateFrom,
  dateTo,
  minimumDays,
  disableFrom,
  numberOfMonths,
  isStacked,
  initialFrom,
  isWishlist = false,
  isCalendarMinimumNightsSelectorEnabled = false,
  ...rest
}: IDatePickerModalContent) => {
  const [initialMonth, setInitialMonth] = useState<Date | undefined>(initialFrom);

  return (
    <DatePicker
      range
      numberOfMonths={numberOfMonths}
      isStacked={isStacked}
      onChange={onChange}
      disabledDays={disabledDays}
      disableBefore={disableBefore}
      dateTo={dateTo}
      dateFrom={dateFrom}
      toMonth={dayjs().add(2, 'year').toDate()}
      minimumDays={minimumDays}
      month={initialMonth}
      onMonthChange={setInitialMonth}
      disableFrom={disableFrom}
      isWishlist={isWishlist}
      isCalendarMinimumNightsSelectorEnabled={isCalendarMinimumNightsSelectorEnabled}
      {...rest}
    />
  );
};
